import React, { useState, useEffect } from 'react'
import CloseIcon from '../../assets/CloseIcon'
import DotsIcon from '../../assets/DotsIcon'
import EditIcon from '../../assets/EditIcon'
import TrashIcon from '../../assets/TrashIcon'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import {
    getAllBanksHelper,
    addBankHelper,
    updateBankHelper,
    deleteBankHelper
} from '../../helper/bank-details-helper'

const BANK_FIELDS = {
    ID: 'id',
    AC_NAME: 'ac_name',
    AC_NUMBER: 'ac_number',
    ROUTING_NUMBER: 'routing_number',
    BANK_NAME: 'bank_name',
    BRANCH_NAME: 'branch_name'
}

const BankDetails = ({ onBackClick, onClose }) => {
    const [banks, setBanks] = useState([])
    const [open, setOpen] = useState(false)
    const [viewOpen, setViewOpen] = useState(false)
    const [bankData, setBankData] = useState({})
    const [selectedBank, setSelectedBank] = useState(null)
    const [isFieldErrorVisible, setIsFieldErrorVisible] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [activeCardIndex, setActiveCardIndex] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        loadBanks()
    }, [])

    const loadBanks = () => {
        getAllBanksHelper()
            .then(res => {
                console.log('Banks loaded: ', res)
                setBanks(res || [])
            })
            .catch(err => {
                console.log('Error loading banks: ', err)
                setBanks([])
            })
    }

    const handleDrawerToggle = () => {
        setOpen(!open)
        if (open) {
            resetForm()
        }
    }

    const handleViewDrawerToggle = () => {
        setViewOpen(!viewOpen)
        if (viewOpen) {
            setSelectedBank(null)
        }
    }

    const handleBankDetailUpdate = (key, value) => {
        setBankData({
            ...bankData,
            [key]: value
        })
    }

    const resetForm = () => {
        setBankData({})
        setIsFieldErrorVisible(false)
        setIsEditMode(false)
    }

    const checkValidation = () => {
        return (
            bankData[BANK_FIELDS.AC_NAME] &&
            bankData[BANK_FIELDS.AC_NUMBER] &&
            bankData[BANK_FIELDS.BANK_NAME]
        )
    }

    const handleSubmit = () => {
        if (!checkValidation()) {
            setIsFieldErrorVisible(true)
            return
        }

        setIsFieldErrorVisible(false)
        setIsLoading(true)

        if (isEditMode) {
            updateBankHelper(bankData)
                .then(res => {
                    console.log('Bank updated: ', res)
                    loadBanks()
                    resetForm()
                    handleDrawerToggle()
                })
                .catch(err => {
                    console.log('Error updating bank: ', err)
                })
                .finally(() => {
                    setIsLoading(false)
                })
        } else {
            addBankHelper(bankData)
                .then(res => {
                    console.log('Bank added: ', res)
                    loadBanks()
                    resetForm()
                    handleDrawerToggle()
                })
                .catch(err => {
                    console.log('Error adding bank: ', err)
                })
                .finally(() => {
                    setIsLoading(false)
                })
        }
    }

    const handleViewBank = (bank) => {
        setSelectedBank(bank)
        setActiveCardIndex(null)
        setViewOpen(true)
    }

    const handleEditBank = (bank) => {
        setBankData(bank)
        setIsEditMode(true)
        setActiveCardIndex(null)
        setOpen(true)
    }

    const handleDeleteBank = (bankId) => {
        deleteBankHelper(bankId)
            .then(res => {
                console.log('Bank deleted: ', res)
                loadBanks()
            })
            .catch(err => {
                console.log('Error deleting bank: ', err)
            })
        setActiveCardIndex(null)
    }

    const toggleCardMenu = (index, e) => {
        e.stopPropagation()
        setActiveCardIndex(activeCardIndex === index ? null : index)
    }

    return (
        <>
            <div className="pageBodyRightPanel">
                <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter webVisible mb-5">
                    <div className="pageBodyRightPanelHeading">Bank Details</div>
                    <div className="addProductBtn dFlex aiCenter">
                        <button
                            className="btn btnPrimary"
                            onClick={handleDrawerToggle}>
                            ADD
                        </button>
                        {onClose && (
                            <div
                                className="pointer ml-4"
                                onClick={() => onClose()}>
                                <CloseIcon />
                            </div>
                        )}
                    </div>
                </div>

                {banks.length === 0 ? (
                    <div className="pageBodyPanelWrap">
                        <div className="emptyState">
                            <p>No bank details added yet. Click ADD to add your first bank.</p>
                        </div>
                    </div>
                ) : (
                    <div className="bankListWrap">
                        <table className="bankTable">
                            <thead>
                                <tr>
                                    <th>Bank Name</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {banks.map((bank, index) => (
                                    <tr
                                        key={bank[BANK_FIELDS.ID] || index}
                                        className="bankRow"
                                        onClick={() => handleViewBank(bank)}>
                                        <td className="bankName">
                                            {bank[BANK_FIELDS.BANK_NAME]}
                                        </td>
                                        <td className="bankActions">
                                            <div className="actionWrapper">
                                                <span
                                                    className="dotsIcon pointer"
                                                    onClick={(e) => toggleCardMenu(index, e)}>
                                                    <DotsIcon />
                                                </span>
                                                {activeCardIndex === index && (
                                                    <ul className="cardActionsWrapper show">
                                                        <li
                                                            className="actionItem"
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                handleEditBank(bank)
                                                            }}>
                                                            <EditIcon /> Edit
                                                        </li>
                                                        <li
                                                            className="actionItem"
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                handleDeleteBank(bank[BANK_FIELDS.ID])
                                                            }}>
                                                            <TrashIcon /> Delete
                                                        </li>
                                                    </ul>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Add/Edit Bank Drawer */}
                <SideDrawer
                    handleDrawerToggle={handleDrawerToggle}
                    open={open}
                    downloadButton={true}
                    downloadText={'SAVE'}
                    drawerHeading={isEditMode ? 'Edit Bank' : 'Add New Bank'}
                    handleClick={() => handleSubmit()}
                    isLoading={isLoading}>
                    <div className="wizardFieldset">
                        <form className="mt-5">
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="text"
                                    className="formControl"
                                    id="acName"
                                    placeholder="A/C Name"
                                    value={bankData[BANK_FIELDS.AC_NAME] || ''}
                                    onChange={e =>
                                        handleBankDetailUpdate(
                                            BANK_FIELDS.AC_NAME,
                                            e.target.value
                                        )
                                    }
                                    required
                                />
                                <label htmlFor="acName">A/C Name</label>
                                {isFieldErrorVisible &&
                                    !bankData[BANK_FIELDS.AC_NAME] && (
                                        <div className="invalidFeedback">
                                            Please enter A/C Name.
                                        </div>
                                    )}
                            </div>
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="text"
                                    className="formControl"
                                    id="acNumber"
                                    placeholder="A/C Number"
                                    value={bankData[BANK_FIELDS.AC_NUMBER] || ''}
                                    onChange={e =>
                                        handleBankDetailUpdate(
                                            BANK_FIELDS.AC_NUMBER,
                                            e.target.value
                                        )
                                    }
                                    required
                                />
                                <label htmlFor="acNumber">A/C Number</label>
                                {isFieldErrorVisible &&
                                    !bankData[BANK_FIELDS.AC_NUMBER] && (
                                        <div className="invalidFeedback">
                                            Please enter A/C Number.
                                        </div>
                                    )}
                            </div>
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="text"
                                    className="formControl"
                                    id="routingNumber"
                                    placeholder="Routing Number"
                                    value={bankData[BANK_FIELDS.ROUTING_NUMBER] || ''}
                                    onChange={e =>
                                        handleBankDetailUpdate(
                                            BANK_FIELDS.ROUTING_NUMBER,
                                            e.target.value
                                        )
                                    }
                                />
                                <label htmlFor="routingNumber">Routing Number</label>
                            </div>
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="text"
                                    className="formControl"
                                    id="bankName"
                                    placeholder="Bank Name"
                                    value={bankData[BANK_FIELDS.BANK_NAME] || ''}
                                    onChange={e =>
                                        handleBankDetailUpdate(
                                            BANK_FIELDS.BANK_NAME,
                                            e.target.value
                                        )
                                    }
                                    required
                                />
                                <label htmlFor="bankName">Bank Name</label>
                                {isFieldErrorVisible &&
                                    !bankData[BANK_FIELDS.BANK_NAME] && (
                                        <div className="invalidFeedback">
                                            Please enter Bank Name.
                                        </div>
                                    )}
                            </div>
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="text"
                                    className="formControl"
                                    id="branchName"
                                    placeholder="Branch Name"
                                    value={bankData[BANK_FIELDS.BRANCH_NAME] || ''}
                                    onChange={e =>
                                        handleBankDetailUpdate(
                                            BANK_FIELDS.BRANCH_NAME,
                                            e.target.value
                                        )
                                    }
                                />
                                <label htmlFor="branchName">Branch Name</label>
                            </div>
                        </form>
                    </div>
                </SideDrawer>

                {/* View Bank Drawer */}
                <SideDrawer
                    handleDrawerToggle={handleViewDrawerToggle}
                    open={viewOpen}
                    drawerHeading="Bank Details">
                    {selectedBank && (
                        <div className="wizardFieldset">
                            <div className="bankViewDetails mt-5">
                                <div className="viewItem">
                                    <div className="viewLabel">A/C Name</div>
                                    <div className="viewValue">
                                        {selectedBank[BANK_FIELDS.AC_NAME] || '-'}
                                    </div>
                                </div>
                                <div className="viewItem">
                                    <div className="viewLabel">A/C Number</div>
                                    <div className="viewValue">
                                        {selectedBank[BANK_FIELDS.AC_NUMBER] || '-'}
                                    </div>
                                </div>
                                <div className="viewItem">
                                    <div className="viewLabel">Routing Number</div>
                                    <div className="viewValue">
                                        {selectedBank[BANK_FIELDS.ROUTING_NUMBER] || '-'}
                                    </div>
                                </div>
                                <div className="viewItem">
                                    <div className="viewLabel">Bank Name</div>
                                    <div className="viewValue">
                                        {selectedBank[BANK_FIELDS.BANK_NAME] || '-'}
                                    </div>
                                </div>
                                <div className="viewItem">
                                    <div className="viewLabel">Branch Name</div>
                                    <div className="viewValue">
                                        {selectedBank[BANK_FIELDS.BRANCH_NAME] || '-'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </SideDrawer>
            </div>
        </>
    )
}

export default BankDetails
